module.exports = __webpack_public_path__ + "static/storage1-bd4d30caf2bc0b4326df988e4c2e4d40.png";